module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/kislinka-avatar-812f9e8a5ae4546b0d0362c41345568e.jpg";